import { useFormikContext } from "formik"
import { FormikSwitch, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { SupplierFormValues } from "../supplierTypes"
import { EntityHistoryAccordion } from "../../components/EntityHistoryAccordion"
import { ContactDetailsContent } from "../../components/form/ContactDetailsContent"
import { InvoiceDetailsContent } from "../../components/form/InvoiceDetailsContent"
import { AddressContent } from "../../components/form/AddressContent"
import { AgreementOwnerContent } from "../../components/form/AgreementOwnerContent"
import { AgreementOptions, EntityHistory } from "../../supportEntitiesTypes"
import { EntityTypeSelect } from "../../components/form/EntityTypeSelect"
import { SubscriptionDetailsContent } from "../../components/form/SubscriptionDetailsContent"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"

type SupplierCreateUpdateContentProps = Readonly<{
    history?: EntityHistory
}>

export function SupplierCreateUpdateContent({ history }: SupplierCreateUpdateContentProps) {
    const { values } = useFormikContext<SupplierFormValues>()

    return (
        <StandardForm>
            <StandardMainPanel>
                <AgreementOwnerContent />
            </StandardMainPanel>
            <StandardMainPanel>
                <EntityTypeSelect />
                <LocalizedStrict id="support-create-supplier-company-number-label" attrs={{ label: true }}>
                    <FormikTextField<SupplierFormValues>
                        name="businessNumber"
                        label="Company number"
                        sx={{ width: "18rem" }}
                    />
                </LocalizedStrict>
                <LocalizedStrict id="support-create-supplier-company-name-label" attrs={{ label: true }}>
                    <FormikTextField<SupplierFormValues> name="name" label="Company name" fullWidth />
                </LocalizedStrict>
                <AddressContent />
            </StandardMainPanel>
            {values.isSystemOwner === AgreementOptions.YES && (
                <StandardMainPanel>
                    <SubscriptionDetailsContent />
                </StandardMainPanel>
            )}
            <StandardMainPanel>
                <ContactDetailsContent />
            </StandardMainPanel>
            {values.isSystemOwner === AgreementOptions.YES && (
                <StandardMainPanel>
                    <InvoiceDetailsContent />
                </StandardMainPanel>
            )}

            <LocalizedStrict id="support-create-supplier-aside-settings" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="support-create-supplier-aside-active">
                        <FormikSwitch<SupplierFormValues> name="isActive">Active:</FormikSwitch>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>

            {history && (
                <LocalizedStrict id="support-create-entity-aside-history" attrs={{ title: true }}>
                    <StandardSidePanel variant="collapsible" title="History">
                        <EntityHistoryAccordion history={history} />
                    </StandardSidePanel>
                </LocalizedStrict>
            )}
        </StandardForm>
    )
}
